import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { STORAGE_KEYS } from '~constants'
import { ConsultationData } from '~containers/app/ask-a-vet/types'
import { store } from '~store/general'

export const consultationDataAtom = atomWithStorage<ConsultationData>(
  STORAGE_KEYS.CONSULTATION_DATA,
  new ConsultationData(JSON.parse(localStorage.getItem(STORAGE_KEYS.CONSULTATION_DATA) || '{}')),
  {
    getItem: (key, initialValue) => {
      const storedData = localStorage.getItem(key)
      try {
        return storedData ? new ConsultationData(JSON.parse(storedData)) : initialValue
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        localStorage.removeItem(key)
        return initialValue
      }
    },
    setItem: (key, value) => {
      localStorage.setItem(key, JSON.stringify(value))
    },
    removeItem: key => {
      localStorage.removeItem(key)
    },
  }
)

export const useConsultationData = () => {
  return useAtom(consultationDataAtom)
}

export const resetConsultationData = () => {
  localStorage.removeItem(STORAGE_KEYS.CONSULTATION_DATA)
  store.set(consultationDataAtom, new ConsultationData({}))
}
